module.exports = __webpack_public_path__ + "assets/img/cluster-logo-univ-small.svg";